import ApiClient from '../../../../base/api';
import {
    GetLoginResponse,
    ChangeLoginParams,
    ChangePasswordParams,
    ProfileDataParams,
    ProfileLogoResponse,
} from './interfaces';

const apiClient = new ApiClient();

export const settingsApi = {
    getLogin: () => apiClient.get<GetLoginResponse>('/api/profile/email'),
    getProfileData: () => apiClient.get<ProfileDataParams>('/api/profile'),
    submitProfile: (data: ProfileDataParams) => apiClient.post<ProfileDataParams, void>('/api/profile', data),
    saveLogo: (file: File) => {
        const formData = new FormData();
        formData.append('image', file);
        return apiClient.post<FormData, ProfileLogoResponse>('/api/profile/image', formData, {
            headers: {
                'Content-type': 'multipart/form-data',
            },
        });
    },
    changeLogin: (data: ChangeLoginParams) => apiClient.post<ChangeLoginParams, void>('/api/profile/email', data),
    changePassword: (data: ChangePasswordParams) =>
        apiClient.post<ChangePasswordParams, void>('/api/profile/password', data),
};
